"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceConditionalTokens = void 0;
const transformations_1 = require("../../transformations");
const conditional_token_regexp_1 = require("../../lib/conditional-token-regexp/conditional-token-regexp");
const replaceConditionalTokens = (html, replacer) => {
    return html.replace((0, conditional_token_regexp_1.getConditionalTokenRegexp)(), (_, encodedTokenData) => {
        return replacer((0, transformations_1.dataFromBase64)(encodedTokenData));
    });
};
exports.replaceConditionalTokens = replaceConditionalTokens;
//# sourceMappingURL=replace-conditional-tokens.js.map